import React from 'react';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Modal, Grid, List, Icon, Divider, Popup } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
class GeneratingPlaybookDetailsModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open:false,
            practice:{}
        }
    }

    handleClose = () => {
        this.setState({open:false,practice:{}});
        dispatch.lifeCycle.setSelectedPracticeLibrary({})
    }
    componentDidUpdate(prevProps) {
        if (prevProps.selectedPracticeLibrary !== this.props.selectedPracticeLibrary) {
            if(this.props.selectedPracticeLibrary &&
                this.props.selectedPracticeLibrary.status === -1){
                    this.setState({open:true})
            }
            if (this.props.selectedPracticeLibrary && Object.keys(this.props.selectedPracticeLibrary).length > 0) {
                this.setState({ practice: this.props.selectedPracticeLibrary });
            }
        }
    }
    openPlaybook = () => {
        const history = this.props.history;
        history.push({pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.selectedOrganisation.id}/_pb/steps/${this.state.practice._id}/sequence`})
        dispatch.lifeCycle.setSelectedTreeId(2);
        dispatch.lifeCycle.setTreeCurrentPath("0/0");
        this.setState({open:false,practice:{}})
    }
    deletePlaybook = (e) => {
        let message = <div className="confirmMessage">
          <h3>Delete Playbook</h3>
          <label>{this.state.practice.name}</label>
          <p>Are you sure to remove this Playbook?</p>
          <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
    
          onOk: () => {
            dispatch.app.setCollapsedResourcePaneIndexTemp(null);
            let payload = {}
            payload.type = 'removePack';
            payload.packid = this.state.practice._id;
            payload.accountId = this.props.selectedAccount._id;
            payload.organizationId = this.props.selectedOrganisation.id;
            payload.userid = this.props.user._id;
            payload.baseId = this.state.practice.baseId;
            this.handleClose();
            dispatch.lifeCycle.deletePlaybook(payload);
            dispatch.lifeCycle.setArrangementPaneFlag(false);
          }
        });
      }
      regeneratePlaybook = async (e) => {
        let message = <div className="confirmMessage">
          <h3>Regenerate Playbook</h3>
          <label>{this.props.selectedPracticeLibrary.name}</label>
          <p>Are you sure to Regenerate this Playbook?</p>
          <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
          onOk: async () => {
            this.setState({regeneratePlaybookFlag:true})
            dispatch.app.setCollapsedResourcePaneIndexTemp(null);
            let topic = this.props.selectedPracticeLibrary.genParams.find((params)=>params.key === 'topic');
            const payload = {
              topic: topic ? topic.value.replace(/\s*\(\d+\)$/, '') : this.props.selectedPracticeLibrary.name.replace(/\s*\(\d+\)$/, ''),
              attributes: this.props.selectedPracticeLibrary.genParams.map((elem) => {
                return {
                  key: elem.key,
                  value: elem.value,
                };
              }),
              baseCategory: this.props.selectedPracticeLibrary.baseCategory,
              category: this.props.selectedPracticeLibrary.category,
              subCategory: this.props.selectedPracticeLibrary.subCategory,
              playbook : this.props.selectedPracticeLibrary
            }
            await dispatch.lifeCycle.getPlayBookDescription(payload)
            dispatch.lifeCycle.setArrangementPaneFlag(false);
            this.setState({regeneratePlaybookFlag:false})
          }
        });
      }
    renderPhases = () => {
        const { practice } = this.state;
        const data = {
        totalPhasesArray: practice.generativeLogs && practice.generativeLogs.phases ? practice.generativeLogs.phases : [],
        completedPhases: practice.generativeLogs && practice.generativeLogs.phasesCompleted ? practice.generativeLogs.phasesCompleted : [],
        currentPhase: practice.generativeLogs && practice.generativeLogs.phases && practice.generativeLogs.phasesCompleted && practice.generativeLogs.phases.length > practice.generativeLogs.phasesCompleted.length
            ? practice.generativeLogs.phases[practice.generativeLogs.phasesCompleted.length]
            : ''
        };
        if(practice.status === 0){
            data.completedPhases = data.totalPhasesArray
            data.currentPhase = ""
        }
        return (
            <List style={{
                margin: '20px auto',
                padding: '10px',
                maxWidth: '400px',
                borderRadius: '8px',
                backgroundColor: '#fff',
              }}>
                {data.totalPhasesArray.map(phase => {
                    let icon, color;
                    if (data.completedPhases.includes(phase)) {
                        icon = 'check circle';
                        color = 'green';
                    } else if (data.currentPhase === phase) {
                        icon = 'circle notched';
                        color = 'blue';
                    } else {
                        icon = 'hourglass half';
                        color = 'grey';
                    }
                    return (
                        <div style={{
                            padding: '10px 15px',
                            display: 'flex',
                            alignItems: 'center',
                          }}>
                            <Icon name={icon} style={{
                                    color: color === 'grey' ? '#C5C6D0' : color,
                                    marginRight: '10px',
                                }} size='large' loading={icon === 'circle notched'}/>
                            <div>
                              <h3 style={{ fontSize: '24px' }}>{phase}</h3>
                            </div>
                          </div>
                    );
                })}
            </List>
        );
    }

    render() {
      const { name } = this.state.practice;
    const truncatedName = name && name.length > 50 ? `${name.slice(0, 47)}...` : name;
        return (
            <Modal
                style={inlineStyle.modal}
                open={this.state.open}
                onClose={this.handleClose}
                size='small'
                className="basicModal"
                closeOnEscape={false}
                closeOnDimmerClick={false}
                closeIcon
            >
                <Modal.Header style={{ color: '#3fa9f5' }}>
                  <Popup
                    inverted
                    className="popupStyled"
                    content={name}
                    trigger={<div>{truncatedName}</div>}
                    disabled={name && name.length <= 50}
                  />
                </Modal.Header>
                <Divider style={{ margin: "10px 0 0px" }} />
                <Form
                    name="rejectionNotesForm"
                    id="rejectionNotesForm"
                >

                    <Modal.Content>

                        <Grid columns={1}>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    {this.state.practice.generativeLogs && Object.keys(this.state.practice.generativeLogs).length > 0 ? this.renderPhases():
                                    this.state.practice.playbookGenerationStatus !== -1 &&  <div style={{
                                      textAlign: 'center',
                                      padding: '6px',
                                      fontSize: '12px',
                                      margin: '20px auto',
                                    }}>
                                      <div style={{
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                      }}>
                                        Generating phases and stages...
                                      </div>
                                      <div style={{
                                        marginTop: "60px", 
                                        marginBottom: "60px"
                                      }}>
                                        <div className="generatingLoader"></div>
                                      </div>
                                    </div>}
                                    {this.state.practice.playbookGenerationStatus === -1 && <div style={{
                                        textAlign: 'center',
                                        padding: '8px',
                                        borderRadius: '5px',
                                        fontSize:'12px',
                                        margin: '20px auto',
                                      }}>
                                        <Icon style={{marginBottom:"5px"}} name='exclamation circle' color='red' size='large' />
                                        <div style={{ 
                                          display: 'inline-block', 
                                          marginLeft: '5px', 
                                          fontSize: '14px',
                                          fontWeight: 'bold',
                                          color: '#d8000c' 
                                        }}>Oops error <span style={{fontSize:'16px'}}>!</span></div>
                                        <div style={{
                                          marginTop: '10px',
                                          marginLeft: '24px',
                                          fontWeight: 'bold'
                                        }}>Please regenerate Playbook</div>
                                      </div>}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                    <Modal.Actions className="actionInFormcy">
                    <Button style={{backgroundColor:"red"}}
                            id='deletebtn'
                            type="button"
                            className="button-warning"
                            onClick={() => this.deletePlaybook()}
                            disabled={this.state.practice.status !== -1}> Delete Playbook</Button>
                        {this.state.practice.playbookGenerationStatus !== -1 ?<Button color='green'
                            id='addbtn'
                            type="button"
                            className="button-submit"
                            onClick={() => this.openPlaybook()}
                            disabled={this.state.practice.status === -1}> Open Playbook</Button> :<Button color='green'
                            id='addbtn'
                            type="button"
                            className="button-regenerate"
                            onClick={() => this.regeneratePlaybook()}
                        disabled={this.state.practice.playbookGenerationStatus !== -1}> Regenerate Playbook</Button>}
                    </Modal.Actions>
                </Form>
            </Modal>
        )
    }
}

const inlineStyle = {
    modal: {
        maxWidth:'400px'
    }
};

export default GeneratingPlaybookDetailsModal;
